// extracted by mini-css-extract-plugin
module.exports = {"resendContainer":"EmailStatementModal_resendContainer__3Nq_g","message":"EmailStatementModal_message__2SGFh"};